import React, { useEffect, useState } from "react";
// Agregamos FaPlus para el botón manual de Nuevo y FaLink para el Gestor
import { FaEdit, FaTrashAlt, FaLink, FaPlus } from "react-icons/fa";

import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

import FiltroImpuesto from "./FiltroImpuesto";
import CrearImpuesto from "./CrearImpuesto";
import EditarImpuesto from "./EditarImpuesto";
import EliminarImpuesto from "./EliminarImpuesto";

// IMPORT DEL NUEVO GESTOR INTEGRAL
import GestionarCertificadoModal from "../../../components/Modales/GestionarCertificadoModal";

// === IMPORTAMOS LOS BOTONES REUTILIZABLES ===
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnLimpiarSeleccion from "../../../components/buttons/BtnLimpiarSeleccion"; 
// import BtnCancelar from "../../../components/buttons/BtnCancelar"; 

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarImpuesto() {
  // ================================
  //   PAGINACIÓN
  // ================================
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);

  // ================================
  //   DATA TABLA PRINCIPAL
  // ================================
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================================
  //   CACHE PARA EL MODAL (PREFETCH - BACKGROUND)
  // ================================
  const [cacheClientes, setCacheClientes] = useState([]);

  // Modales
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [registroAEditar, setRegistroAEditar] = useState(null);
  const [registroAEliminar, setRegistroAEliminar] = useState(null);

  // ESTADO NUEVO: Para el Modal del Gestor Integral
  const [mostrarGestorCompleto, setMostrarGestorCompleto] = useState(false);

  // Filtros
  const [filtros, setFiltros] = useState({
    numero: "",
    data: "",
    dataFechaini: "",
    dataFechafin: "",
    dataIngreso: ""
  });

  const [reloadKey, setReloadKey] = useState(0);

  // ================================
  //   1. CARGA DE LA TABLA (PRINCIPAL)
  // ================================
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        let baseUrl = apiRoutes.certificados.listUrl({});

        if (baseUrl.includes("?")) {
          baseUrl = baseUrl.split("?")[0];
        }

        const queryParams = new URLSearchParams();
        queryParams.append("page", pagina - 1);
        queryParams.append("size", porPagina);
        
        // Mapeo de Filtros
        if (filtros.numero) queryParams.append("numero", filtros.numero.trim());
        if (filtros.data) queryParams.append("data", filtros.data);
        if (filtros.dataFechaini) queryParams.append("dataFechaini", filtros.dataFechaini);
        if (filtros.dataFechafin) queryParams.append("dataFechafin", filtros.dataFechafin);
        if (filtros.dataIngreso) queryParams.append("dataIngreso", filtros.dataIngreso);

        const url = `${baseUrl}?${queryParams.toString()}`;
        const res = await appFetchJson(url);

        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);

        const total =
          res?.totalElements ??
          res?.total ??
          (Array.isArray(items) ? items.length : 0);

        setTotalBackend(total);

      } catch (e) {
        console.error("Error cargando certificados:", e);
        setError("Error al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  // ================================
  //   2. PRECARGA DE CATÁLOGOS (BACKGROUND)
  // ================================
  useEffect(() => {
    const cargarCatalogosBackground = async () => {
      try {
        const urlCli = apiRoutes.clientes?.listUrl
             ? apiRoutes.clientes.listUrl({ size: 3000 })
             : `${apiRoutes.API_BASE || ''}/clientes/list?size=3000`;

        const resCli = await appFetchJson(urlCli);
        const rawItems = Array.isArray(resCli.content) ? resCli.content : (resCli.items || []);

        const itemsMapped = rawItems.map((c) => ({
            id: c.id,
            codigo: c.codigo || "", 
            nombre: c.nombre || c.razonSocial || c.label || "Cliente sin nombre" 
        }));

        setCacheClientes(itemsMapped);

      } catch (e) {
        console.warn("No se pudieron precargar los clientes en segundo plano", e);
      }
    };

    cargarCatalogosBackground();
  }, []); 


  // ================================
  //   FORMATO DE FECHA
  // ================================
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    if (/[a-zA-Z]/.test(dateString) && dateString.includes("-")) {
        return dateString; 
    }
    const fecha = new Date(dateString);
    if (isNaN(fecha.getTime())) {
        return dateString;
    }
    const dia = fecha.getDate().toString().padStart(2, '0');
    const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    const mes = meses[fecha.getMonth()];
    const anio = fecha.getFullYear();
    
    return `${dia}-${mes}-${anio}`; // Sin hora para la tabla
  };

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (DYNAMIC TABLE)
  // ====================================================================
  const columns = [
    // 1. NRO. CERTIFICADO (20%)
    { 
      header: "Nro. Certificado", 
      accessor: "numero",
      type: "text", 
      width: "20%", 
      cellClass: "font-medium text-gray-800 break-all" 
    },
    // 2. FECHA CERT. (15%)
    { 
      header: "Fecha Cert.", 
      type: "center", 
      width: "15%", 
      render: (row) => formatDate(row.data)
    },
    // 3. FECHA INICIO (15%)
    { 
      header: "Fecha Inicio", 
      type: "center", 
      width: "15%", 
      render: (row) => formatDate(row.dataFechaini)
    },
    // 4. FECHA FIN (15%)
    { 
      header: "Fecha Fin", 
      type: "center", 
      width: "15%", 
      render: (row) => formatDate(row.dataFechafin)
    },
    // 5. FECHA INGRESO (15%)
    { 
      header: "Fecha Ingreso", 
      type: "center", 
      width: "15%", 
      render: (row) => formatDate(row.dataIngreso)
    },
    // 6. ACCIÓN (20%)
    {
      header: "Acción",
      type: "action", 
      width: "20%",
      render: (it) => (
        <div className="flex justify-center items-center gap-2">
          <button
            className="text-gray-500 hover:text-blue-600 p-1"
            title="Editar"
            onClick={() => {
              setRegistroAEditar(it);      
              setMostrarGestorCompleto(true);
            }}
          >
            <FaEdit />
          </button>

          <button
            className="text-gray-500 hover:text-red-600 p-1"
            title="Eliminar"
            onClick={() => setRegistroAEliminar(it)}
          >
            <FaTrashAlt />
          </button>
        </div>
      )
    }
  ];

  // ================================
  //   RENDER
  // ================================
  return (
    <div className="page">

      {/* HEADER */}
      <h1 className="page-title">Impuesto al valor selectivo (Certificados)</h1>

      <div className="toolbar">
        <div className="inline-flex items-center gap-2">
          
          <button
            className="btn-fil"
            onClick={() => setMostrarFiltros(true)}
          >
            Ver Filtros
          </button>

          {/* === BOTÓN LIMPIAR REUTILIZABLE === */}
          <BtnLimpiarSeleccion
             filters={filtros}
             label="Limpiar Filtros"
             onClick={() => {
               setFiltros({
                   numero: "", data: "", dataFechaini: "", dataFechafin: "", dataIngreso: ""
               });
               setPagina(1);
             }}
          />

          {/* === BOTÓN ORIGINAL RESTAURADO === */}
          <BtnGuardar
             label={<><FaLink /> Crear certificado</>}
             onClick={() => {
               setRegistroAEditar(null); //Limpia el estado de edición
               setMostrarGestorCompleto(true);
             }} 
             className="flex items-center justify-center gap-2"
          />

        </div>
      </div>

      <div className="control-block">
        <label className="label-strong">Mostrar por página:</label>
        <select
          value={porPagina}
          onChange={(e) => {
             setPorPagina(Number(e.target.value));
             setPagina(1);
          }}
          className="select"
        >
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {/* DRAWER FILTROS */}
      {mostrarFiltros && (
        <FiltroImpuesto
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
            setFiltros(nuevosFiltros);
            setPagina(1);
            setMostrarFiltros(false);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {/* === TABLA DYNAMIC TABLE (REEMPLAZA LA <table> MANUAL) === */}
      {!loading && (
        <DynamicTable 
          size="M" // Breakpoint en 1024px
          data={data}
          columns={columns}
        />
      )}

      {/* FOOTER */}
      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {/* MODAL: Crear Simple */}
      {mostrarCrear && (
        <CrearImpuesto
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setReloadKey((k) => k + 1);
            setMostrarCrear(false);
          }}
        />
      )}

      {/* MODAL: Eliminar */}
      {registroAEliminar && (
        <div className="modal-backdrop" onClick={() => setRegistroAEliminar(null)}>
          <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
            <EliminarImpuesto
              registro={registroAEliminar}
              onClose={() => setRegistroAEliminar(null)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setRegistroAEliminar(null);
              }}
            />
          </div>
        </div>
      )}

      {/* MODAL: GESTOR INTEGRAL (SIRVE PARA CREAR Y EDITAR) */}
      {mostrarGestorCompleto && (
        <GestionarCertificadoModal
          // 1. Pasamos el registro. Si es null es CREAR, si tiene datos es EDITAR.
          certificadoAEditar={registroAEditar}
          
          // 2. Pasamos la lista de clientes (cache)
          listaClientesPreloaded={cacheClientes} 

          // 3. Al cerrar, cerramos el modal Y limpiamos el registro editado
          onClose={() => {
             setMostrarGestorCompleto(false);
             setRegistroAEditar(null); 
          }}
          
          // 4. Al finalizar exitosamente, recargamos la tabla
          onFinish={() => {
            setMostrarGestorCompleto(false);
            setRegistroAEditar(null);
            setReloadKey((k) => k + 1); 
          }}
        />
      )}

    </div>
  );
}